import { Pagination } from "@/modules/common/types/Pagination";

import api from "../api";
import {
  ConfirmKnowledgeBaseUploadDto,
  CreateKnowledgeBaseContentDto,
  GenerateKnowledgeBaseUploadUrlDto,
  ListAdminKnowledgeBaseDto,
  UpdateKnowledgeBaseContentDto,
} from "../dto/admin-knowledge-base";
import {
  ConfirmKnowledgeBaseUploadResponse,
  GenerateKnowledgeBaseUploadUrlResponse,
  KnowledgeBaseContentListItemResponse,
  KnowledgeBaseContentResponse,
} from "../response/admin-knowledge-base";

export const ADMIN_KNOWLEDGE_BASE_ENDPOINTS = {
  LIST: "/v1/admin/knowledge-base",
  DETAIL: (id: string) => `/v1/admin/knowledge-base/${id}`,
  GENERATE_UPLOAD_URL: "/v1/admin/knowledge-base/media/generate-upload-url",
  CONFIRM_UPLOAD: "/v1/admin/knowledge-base/media/confirm-upload",
};

const joinList = (values?: number[]) => (values?.length ? values.join(",") : undefined);

export const AdminKnowledgeBaseService = {
  list: async ({ statuses, categories, types, audiences, ...params }: ListAdminKnowledgeBaseDto = {}): Promise<Pagination<KnowledgeBaseContentListItemResponse>> => {
    const response = await api.get(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.LIST, {
      params: { ...params, statuses: joinList(statuses), categories: joinList(categories), types: joinList(types), audiences: joinList(audiences) },
    });
    return response.data;
  },

  get: async (id: string): Promise<KnowledgeBaseContentResponse> => {
    const response = await api.get(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.DETAIL(id));
    return response.data;
  },

  create: async (data: CreateKnowledgeBaseContentDto): Promise<KnowledgeBaseContentResponse> => {
    const response = await api.post(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.LIST, data);
    return response.data;
  },

  update: async (id: string, data: UpdateKnowledgeBaseContentDto): Promise<KnowledgeBaseContentResponse> => {
    const response = await api.put(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.DETAIL(id), data);
    return response.data;
  },

  generateUploadUrl: async (data: GenerateKnowledgeBaseUploadUrlDto): Promise<GenerateKnowledgeBaseUploadUrlResponse> => {
    const response = await api.post(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.GENERATE_UPLOAD_URL, data);
    return response.data;
  },

  confirmUpload: async (data: ConfirmKnowledgeBaseUploadDto): Promise<ConfirmKnowledgeBaseUploadResponse> => {
    const response = await api.post(ADMIN_KNOWLEDGE_BASE_ENDPOINTS.CONFIRM_UPLOAD, data);
    return response.data;
  },
};
